import { MsalContext } from '@azure/msal-react';
import { useContext } from 'react';

export default function useMsalAuthContext() {
  const { accounts, instance } = useContext(MsalContext);
  const isAzureAuthenticated = accounts.length > 0;

  /**
   * Signs the current Azure user out and returns them to the homepage.
   */
  function handleLogout() {
    if (!isAzureAuthenticated) {
      return;
    }

    const logoutRequest = {
      account: accounts[0],
      postLogoutRedirectUri: window.location.origin,
    };

    sessionStorage.clear();
    void instance.logoutRedirect(logoutRequest);
  }

  return {
    handleLogout,
    isAzureAuthenticated,
  };
}
